<template>
  <div class="login">
    <h1>
      {{ title }}
    </h1>
    <p v-if="GoogleUser.validDomain === false">
      Only users from SeenThis are allowed
    </p>
    <button
      v-if="!doneLoading"
      id="signin"
      type="submit"
      class="signin"
      :class="{ disabled: isLoading }"
      @click="signIn"
    >
      <span v-if="!isLoading">Sign in</span>
      <span v-else>Signing in...</span>
    </button>
    <div class="morph-container">
      <textMorph
        v-if="doneLoading"
        :texts="['Perfect!', 'Welcome to ..', 'SeenThis Portal!', '=]']"
        :fontSize="50"
        :morphSpeed=".2"
        :cooldownTime=".3"
        :program="'single'"
        :doneCallback="redirect"
      ></textMorph>
    </div>
  </div>
</template>

<script>

import textMorph from '@/components/text-morph.vue';

import awsconfig from '@/aws-exports';

import {
  getRefreshToken,
  refreshAuth,
  createaAuthTokens,
  getUserData,
} from '@/utils/authManager';

export default {
  name: 'login',
  components: {
    textMorph,
  },
  data() {
    return {
      title: 'SeenThis Portal',
      isLoading: false,
      doneLoading: false,
    };
  },
  async created() {
    // Parse URL parameters to get tokens
    const inParams = new URLSearchParams(window.location.search);
    const authCode = inParams.get('code');

    if (getRefreshToken()) {
      refreshAuth();
    } else if (authCode) {
      this.isLoading = true;
      const res = await createaAuthTokens(authCode);
      if (res && getUserData().validDomain) {
        this.doneLoading = true;
      }
      this.isLoading = false;
    }
  },
  methods: {
    signIn() {
      const queryParams = new URLSearchParams({
        response_type: 'code',
        client_id: awsconfig.aws_user_pools_web_client_id,
        redirect_uri: awsconfig.oauth.redirectSignIn,
        state: this.$route.query.ret || '',
      });
      const loginUrl = `https://${awsconfig.oauth.domain}/login?${queryParams.toString()}`;
      window.location.href = loginUrl;
    },
    redirect() {
      const inParams = new URLSearchParams(window.location.search);
      window.location.href = inParams.get('state') || '/';
    },
  },
};
</script>
<style lang="stylus" scoped>
  @require '../style/colors'

  h1
    font-weight: normal
    margin-bottom: 60px

  .login
    display: flex
    align-items: center
    justify-content: center
    flex-direction: column
    height: 100vh

  .morph-container
    height: 100px
    width: 700px

  .signin
    width: 250px
    background-color: $primary-color
    color: $white
    font-size: 2.2rem
    padding: 1.5rem 3rem
    border: none
    border-radius: .5rem
    cursor: pointer
    transition: background-color 0.3s ease-in-out

    &:hover
      background-color: darken($primary-color, 10%)

    &.disabled
      pointer-events: none
      opacity: 0.6

</style>
